import { REACT_APP_BE_API_URL } from '#shared';

import { fetchWithAuthHeaders } from '../fetchWithAuthHeaders';

import type { NOPSRegion } from '#entities';

const paths = {
  surgeonsRegions: 'api/surgeons/regions',
} as const;

export const appDataApi = {
  getSurgeonsRegions: async (): Promise<NOPSRegion[]> => {
    try {
      const url = `${REACT_APP_BE_API_URL}${paths.surgeonsRegions}`;
      const response = await fetchWithAuthHeaders(url);
      return response.items ?? [];
    } catch (err) {
      console.error('Error fetching surgeon regions:', err);
      return [];
    }
  },
};
